module.exports = __webpack_public_path__ + "img/welcome_icon.18ae735d.svg";